import styled from 'styled-components';
import { hideScrollbar, mediaQueries } from '@fourthwall/components';
export const LoaderWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 450px;
`;
export const Content = styled.div `
  display: grid;
  grid-template-columns: 264px 1fr;
  overflow: scroll;
`;
export const Sidebar = styled.div `
  ${hideScrollbar};
  padding: var(--space-500);
  overflow: scroll;
`;
export const HeadingContainer = styled.div `
  display: grid;

  grid-auto-flow: column;
  gap: 16px;
  align-items: center;
  justify-content: start;

  padding-bottom: var(--space-400);
`;
export const SectionWrapper = styled.div `
  & + & {
    margin-top: var(--space-500);
  }
`;
export const SectionHeader = styled.div `
  padding-bottom: var(--space-150);

  color: var(--text-secondary);
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-200);
  letter-spacing: var(--font-letter-spacing-looser);
`;
export const SectionContent = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-100);
`;
export const PreviewsContainer = styled.div `
  ${hideScrollbar};

  display: flex;

  flex-direction: column;
  justify-content: center;
  align-items: center;

  height: calc(100vh - 180px);
  min-height: 450px;

  padding: 20px;

  background: var(--bg-transparent);
  overflow: scroll;

  ${mediaQueries.tablet} {
    height: 100%;
  }
`;
export const SinglePreviewContainer = styled.div `
  width: 100%;
  height: 100%;
`;
export const PreviewsGrid = styled.div `
  display: grid;

  gap: 20px;
  grid-template-columns: repeat(1, 1fr);
  align-self: stretch;
  flex-wrap: wrap;

  ${mediaQueries.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }
`;
export const RecommendedContainer = styled.div `
  display: flex;

  gap: 24px;
  flex-direction: column;

  width: 100%;
  height: 100%;
`;
export const RecommendedGroup = styled.div `
  display: flex;

  gap: 12px;
  flex-direction: column;
`;
export const RecommendedGroupTitle = styled.div `
  font-family: var(--font-family-heading);
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-dense);
`;
